import { useContent } from "@/contexts/ContentContext";
import { Mail, MapPin } from "lucide-react";
import useSEO from "@/hooks/useSEO";

export default function Contact() {
  const { content } = useContent();
  useSEO({
    title: "Contact — Secure Stay Marine | Pile Glide Pro",
    description: "Get a quote on Pile Glide Pro marine pile hoops. Contact Secure Stay Marine Products in Daniel Island, SC. We respond within 1–2 business days.",
    path: "/contact",
  });

  return (
    <div data-testid="contact-page">
      {/* HERO */}
      <section className="border-b-2 border-[#091526]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24">
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl uppercase leading-[0.95] mb-8 max-w-4xl">
            Let's protect your dock.
          </h1>
          <p className="text-base md:text-lg text-[#091526]/80 max-w-2xl leading-relaxed">
            Reach out about your pilings — size, location, and how many you need. We'll
            get back to you with a quote and answer any questions.
          </p>
        </div>
      </section>

      {/* INFO */}
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24 space-y-6">
          <div className="border-2 border-[#091526] bg-[#091526] text-[#F4F4F5] p-8 md:p-10">
            <h3 className="font-display text-3xl md:text-4xl uppercase mb-6 leading-none">Reach us.</h3>
            <ul className="space-y-4 text-base">
              <li className="flex items-center gap-3" data-testid="contact-info-email">
                <Mail size={20} className="text-[#1E5BB8] flex-shrink-0" />
                <a
                  href={`mailto:${content.contact_email}`}
                  className="hover:text-[#1E5BB8] transition-colors break-all"
                >
                  {content.contact_email}
                </a>
              </li>
              {content.contact_address && (
                <li className="flex items-start gap-3" data-testid="contact-info-address">
                  <MapPin size={20} className="text-[#1E5BB8] flex-shrink-0 mt-1" />
                  <span className="leading-relaxed">{content.contact_address}</span>
                </li>
              )}
            </ul>
          </div>

          <div className="border-2 border-[#091526] bg-white p-8">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#1E5BB8] mb-4">
              Response Time
            </div>
            <p className="text-base text-[#091526]/80 leading-relaxed">
              We respond to most inquiries within <strong>1–2 business days</strong>.
            </p>
          </div>

          <div className="h-28 w-48 border-2 border-[#091526] bg-white flex items-center justify-center p-2">
            <img
              src="/images/logo.png"
              alt="Pile Glide Pro"
              className="max-h-full max-w-full object-contain"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
